<!-- 视频列表 -->
<template>
  <div class="opening-view">
    <div class="card" v-for="(item, index) in dataList" :key="index" @click="toVideo(item)">
      <img class="card-bg-img" :src="item.bgimg"/>
      <div class="card-text">
        <div class="plr15">{{item.date}}</div>
        <div class="plr15">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import config from '../../config/pageContent.js'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      dataList: [],
      appId: '',
      uuid: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toVideo(item) {
      this.$router.push({
        name: 'play',
        query: {
          vid: item.vid,
          video: item.url
        }
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  /**
   * 页面参数：
   * theme: App标示，会根据该字段取不同config
   * title: 自定义title（非必填）
   * uuid: 统计使用uuid
   */
  created () {
    var params = this.$route.query;
    var key = params['theme'];
    window.location.title = '视频列表';
    if (params['title']) {
      var title = params['title'];
      window.location.title = title;
    }
    if (params['uuid']) {
      this.uuid = params['uuid'];
    }
    console.log(config);
    var cfg = config[key];
    this.dataList = cfg['videoList'];
    this.appId = cfg['app_id'];
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.opening-view {
  padding: 15px;
}
.card {
  position: relative;
}
.card-text {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0%;
  height: 100%;
  display: flex;
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FAFAFA;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
}
.plr15 {
  padding: 0px 15px;
}
.card-bg-img {
  width: 100%;
}
</style>
